var zh = {
	"common": {
		"viewmore": "排行榜",
		"shopdetail": "门店详情",
		"account": "我的账户",
		"allgoods": "所有商品",
		"newarrivals": "近期上新",
		"hot": "热卖商品",
		"sale": "折扣商品",
		"oldprice": "原价",
		"nowprice": "现价",
		"sellcount": "销量",
		"coupan": "优惠券",
		"buy": "购买",
		"size": "尺码",
		"rest": "剩余",
		"coupantext": "店主暂时没有上架店铺优惠券哦~",
	}
}

export default zh